const links = [
  {
    type: "misc",
    link: "health-insurance-price-negotiation",
    title: "Health Insurance Price Negotiation",
    subtitle: "Feb 2026 / Personal / Insurance",
  },

  {
    type: "misc",
    link: "nghttp2",
    title: "NGHTTTP2",
    subtitle: "Jan 2026 / Commission / Networks",
  },
  {
    type: "web",
    link: "clinical",
    title: "Clinical Trial Data Automation",
    subtitle: "Aug 2025 / Startup / Data Automation",
  },

  {
    type: "web",
    link: "domain-enum",
    title: "Domain Enum",
    subtitle: "May 2025 / Commission / App",
  },
  {
    type: "web",
    link: "proximus",
    title: "Parliment History",
    subtitle: "May 2025 / School / App",
  },
  {
    type: "hack",
    link: "devfest2025",
    title: "DevFest 2025 [winner]",
    subtitle: "Feb 2025 / Hackathon / AI",
  },
  {
    type: "hack",
    link: "spectrumx",
    title: "SpectrumX",
    subtitle: "Sep 2024 / Hackathon / Networks",
  },
  {
    type: "web",
    link: "visaq",
    title: "Visaq",
    subtitle: "Jun 2024 / Personal / Website",
  },
  {
    type: "web",
    link: "hamilton-college-iss",
    title: "Hamilton College ISS",
    subtitle: "May 2024 / Commission / College",
  },
  {
    type: "web",
    link: "give-with-gifted",
    title: "Give With Gifted",
    subtitle: "Apr 2024 / Commission / Shopify",
  },
  {
    type: "misc",
    link: "stroke",
    title: "Stroke Prediction",
    subtitle: "Apr 2024 / School / ML Python",
  },
  {
    type: "misc",
    link: "digdug",
    title: "Dig Dug",
    subtitle: "Nov 2023 / School / x86 Asm",
  },
  {
    type: "misc",
    link: "drawing",
    title: "Drawing Robot",
    subtitle: "May 2023 / Personal / Raspberry Pi",
  },
  {
    type: "misc",
    link: "wordle-solver",
    title: "Wordle Solver",
    subtitle: "Nov 2022 / Personal / Python",
  },
];

export default links;
